import {hitGoogleTagManager} from "../../../tracking/google_tag_manager/init_google_tag_manager";

enum GTMEvent {
    PRICE_LANDING = "price_landing"
}

export enum PricesReportGTMViewAction {
    ROOMS = "rooms",
    INVEST_MAP_CLICK = "invest_map_click",
    OFFER_BUTTON_CLICK = "offer_button_click",
    BIG_DATA_CLICK = "bigdata_click"
}

const viewEvent = (action: PricesReportGTMViewAction | string, data: Record<string, string> = {}) => {
    hitGoogleTagManager({event: GTMEvent.PRICE_LANDING, price_action: action, ...data});
};

export const pricesReportAnalytics = {
    gtm: {
        viewEvent
    }
};
import {hitGoogleTagManager} from "../../../tracking/google_tag_manager/init_google_tag_manager";

enum GTMEvent {
    PRICE_LANDING = "price_landing"
}

export enum PricesReportGTMViewAction {
    ROOMS = "rooms",
    INVEST_MAP_CLICK = "invest_map_click",
    OFFER_BUTTON_CLICK = "offer_button_click",
    BIG_DATA_CLICK = "bigdata_click"
}

const viewEvent = (action: PricesReportGTMViewAction | string, data: Record<string, string> = {}) => {
    hitGoogleTagManager({event: GTMEvent.PRICE_LANDING, price_action: action, ...data});
};

export const pricesReportAnalytics = {
    gtm: {
        viewEvent
    }
};
